import ProjectSurveyResponses from "../project-survey-responses";
import StudiesSurveyResponsesLayout from "./StudiesSurveyResponsesLayout";

// The report keeps its own layout while sharing the Vendor Project Survey
// Responses controller, API, export flow, and granular permissions.
export default function StudiesList() {
  return (
    <ProjectSurveyResponses
      forceVendorProjectResponseRoute
      forceAllResponseScope
      forceSurveyResponsesReportRoute
      PageLayout={StudiesSurveyResponsesLayout}
    />
  );
}
